if($('.type-detail').length){

   /* if($('.add-to-cart__buttons-wrapper .express-checkout-button').length){
        $('.p-info-wrapper').append($('.express-checkout-button'))
    }*/

    $('.express-checkout-button').text(translation('rychlyNakup'));

        $(function () {
        var bonusSelector = '.mehub-bonus-product-detail-container';
        var targetSelector = '.p-info-wrapper';

        function moveBonusBox() {
            var $bonusBox = $(bonusSelector);
            var $target = $(targetSelector);

            if (!$bonusBox.length || !$target.length) {
            return false;
            }

            if ($bonusBox.data('movedToInfoWrapper')) {
            return true;
            }

            $target.append($bonusBox);
            $bonusBox.data('movedToInfoWrapper', true);

            return true;
        }

        if (moveBonusBox()) {
            return;
        }

        var observer = new MutationObserver(function () {
            if (moveBonusBox()) {
            observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });




    var valueCart = $('#product-detail-form input[name="priceId"]').attr('value')
    $('footer#footer').after(`
        <div class="detailFixedCart">
            <div class="container">
                <div class="left">
                    ${$('.p-final-price-wrapper').html()}
                </div>
                <div class="right">
                    <span class="addToCart btn btn-conversion" data-code="${valueCart}">${translation('koupit')}</span>
                </div>
            </div>
        </div>        
    `)
    if($('.p-info-wrapper .quantity-discounts').length){
        $('.p-info-wrapper').append(`
            <div class="discountInfo">
                <div class="discountInfoWrap">
                    <div class="h3">${translation('mnozstevniSlevy')}</div>
                    <div class="discountInner"></div>
                </div>
            </div>
        `)
        var originalPrice = parseFloat($(".quantity-discounts__table").data("orig-price"));
        var discounts = [];
        $(".js-quantity-discounts__item").each(function () {
            var $item = $(this);
            var title = $item.find(".quantity-discounts__title").text().trim();
            var ratio = parseFloat($item.data("price-ratio"));
            var finalPrice = (originalPrice * ratio).toFixed(2);
            var from = null;
            var to = null;
            if (title.match(/(\d+)\s*-\s*(\d+)/)) {
                var m = title.match(/(\d+)\s*-\s*(\d+)/);
                from = parseInt(m[1], 10);
                to = parseInt(m[2], 10);
            }
            else if (title.match(/(\d+)\s*a více/)) {
                var m2 = title.match(/(\d+)\s*a více/);
                from = parseInt(m2[1], 10);
                to = null;
            }
            else if (title.match(/(\d+)\s*ks/)) {
                var m3 = title.match(/(\d+)\s*ks/);
                from = parseInt(m3[1], 10);
                to = null;
            }

            discounts.push({
                from: from,
                to: to,
                ratio: ratio,
                price: finalPrice
            });
        });
        var html = '';
        discounts.forEach(function(d){
            if (d.from === 1 && d.to !== null) {
                return;
            }
            if (d.to === null) {
                html += `<div class="discountLine"><span class="left">${translation('prinakupunad')} ${d.from} ${translation('ks')}</span> <span class="right">${Number(d.price).ShoptetFormatAsCurrency()}/${translation('kus')}</span></div>`;
            } else {
                html += `<div class="discountLine"><span class="left">${translation('prinakupunad')} ${d.from} ${translation('ks')}</span> <span class="right">${Number(d.price).ShoptetFormatAsCurrency()}/${translation('kus')}</span></div>`;
            }
        });
        html += '';

        $(".discountInner").html(html);
    }
    $('.product-top>.col-xs-12:not(.col-lg-6) .flags .flag').each(function () {
        const t = $(this).text().trim();
        const result = parseDiscountFlag(t);
        const productData = getShoptetDataLayer('product');
        let prize = productData?.priceWithVat;
        let useFromPrefix = false;
        if (prize === undefined) {
            prize = productData?.priceWithVatMin ?? 0;
            useFromPrefix = true; 
        }
        if (result && prize > 0) {
            const discounted = Number((prize / 100) * (100 - result.percent));
            const finalPrice = discounted.ShoptetFormatAsCurrency();
            const prefix = useFromPrefix ? '<small>'+translation('od')+' </small>' : '';
            $('.p-info-wrapper').append(`
                <div class="customCode">
                    <div class="wrap">
                        <p>${translation('pouzijtekod')} 
                            <span>${result.code}</span> 
                            ${translation('slevatext')} ${result.percent}%.
                        </p>
                        <p>
                            ${translation('cenapokodu')}:
                            <strong>${prefix} ${finalPrice}</strong>
                        </p>
                    </div>
                </div>
            `);
        }
    });

    //
    if($('.p-detail>.products-related-header').length){
        $('.products-related-header').text(translation('mohlobyzajimat'))
    }
    if($('#productsAlternative').length){
        $('#productsAlternative .products .product').each(function(){
            var href = $(this).find('a.image').attr('href');
            var $tools = $(this).find('.p-bottom>div .p-tools');
            var buttonExists = $tools.find('a.btn-primary').filter(function(){
                return $(this).attr('href') === href;
            }).length;

            if (!buttonExists) {
                $tools.append('<a href="'+href+'" class="btn btn-primary" aria-hidden="true" tabindex="0">'+translation('detailTopProducts')+'</a>');
            }
        })
    };
    if($('.p-final-price-wrapper .price-save').length){
        var $def = $('.p-final-price-wrapper .price-save');
        var html = $def.html();
        html = html.replace(/from/gi, '<span class="small">'+translation('az')+'</span>');
        $def.html(html);
    }
    $('#p-detail-tabs').removeClass('shp-tabs p-detail-tabs visible-links')
    var flags = $('.product-top>.col-xs-12:not(.col-lg-6) .flags').html() || '';
    var stars = $('.product-top>.col-xs-12:not(.col-lg-6) .stars-wrapper').html();
    var brandName = $('.product-top>.col-xs-12:not(.col-lg-6) a[data-testid="productCardBrandName"] span').text();
    var brandLink = $('.product-top>.col-xs-12:not(.col-lg-6) a[data-testid="productCardBrandName"]').attr('href');
    var topTitle = $('.p-detail>.p-detail-inner>.p-detail-inner-header h1').text();
    var topCode = $('.p-detail>.p-detail-inner>.p-detail-inner-header .p-code').html();
    var customInfoWrapper = `
        <div class="customFlags flags-default flags">${flags}</div>
        <div class="h1">${topTitle}</div>
        <div class="starsLine">
            <p class="starsWrapper">${stars}</p>
            <p class="code">${translation('kod')}: ${topCode}</p>
            <p class="brand">${translation('znacka')}: <a href="${brandLink}">${brandName}</a></p>
        </div>
        <div class="customStockLine"></div>
        <div class="customCart"></div>
    `;
    $('.p-detail-inner-header').prepend(`<div class="customFlags flags-default flags">${flags}</div>`)
    $('.p-detail-info').append(`
        <div class="starsLine">
            <p class="starsWrapper">${stars}</p>
            <p class="code">${translation('kod')}: ${topCode}</p>
            <p class="brand">${translation('znacka')}: <a href="${brandLink}">${brandName}</a></p>
        </div>
    `)
    $('.p-info-wrapper').append(customInfoWrapper);
    if($('.variant-list').length){
        $('.customCart').append($('.p-info-wrapper .p-final-price-wrapper'), '<a href="#customVariants" class="customVariant btn-primary btn" data-toggle="tab" data-external="1" data-force-scroll="true">'+translation('Zvoltevariantu')+'</a>');
    }
    else{
        $('.customCart').append($('.p-info-wrapper .p-final-price-wrapper'), $('.p-info-wrapper .add-to-cart'));
    }
    
    $('.customStockLine').append($('.p-info-wrapper .availability-value'));
    if($('.delivery-time-label').length){
        $('.customStockLine').append('<div class="customDeliveryTime">'+translation('dorucitdo')+': <div class="delivery-time">'+$('.delivery-time').html()+'</div>');
        $('.delivery-time-label').closest('tr').hide();
    }
    if($('.shipping-options').length){
        $('.customStockLine').append($('.shipping-options'));
    };
    $(function() {
        let html = $(".basic-description").html();
        const tabContents = [];
        const regex = /\[custom záložka\]([\s\S]*?)\[\/custom záložka\]/gi;
        $(".basic-description").html(
            html.replace(regex, function(match, content) {
                let $tmp = $("<div>" + content + "</div>");
                let $h5 = $tmp.find("h5").first();
                if ($h5.length === 0) return "";
                let title = $h5.text().trim();
                let slug = title
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .toLowerCase()
                    .replace(/[^\w]+/g, "-")
                    .replace(/^-+|-+$/g, "");
                $h5.remove();
                tabContents.push({
                    id: slug,
                    title: title,
                    html: $tmp.html().trim()
                });
                return "";
            })
        );
        tabContents.forEach(tab => {
            let li = `
                <li class="shp-tab" data-testid="${tab.id}" data-width="0">
                    <a href="#${tab.id}" class="shp-tab-link" role="tab" data-toggle="tab">
                        ${tab.title}
                    </a>
                </li>
            `;
            $("#p-detail-tabs li").first().after(li);
        });
        let out = "";
        tabContents.forEach(tab => {
            out += `
                <div id="${tab.id}" class="tab-pane fade customTabs" role="tabpanel">
                    ${tab.html}
                </div>
            `;
        });
        $("#tab-content").append(out);
    });
    if($('.extended-description').length){
        $('#tab-content').append('<div id="additionalParams" class="tab-pane fade additionalParams" role="tabpanel"></div>')
        $('#additionalParams').append($('.extended-description'));
        $('#p-detail-tabs li[data-testid="tabDescription"]').after('<li class="shp-tab" data-testid="tabadditionalParams" data-width=""><a href="#additionalParams" class="shp-tab-link" role="tab" data-toggle="tab">'+translation('parametry')+'</a></li>')
    }
    if($('li[data-testid="tabRelatedFiles"]').length){
        $('li[data-testid="tabRelatedFiles"] a').text(translation('souvisejicisoubory'))
    }
    if($('li[data-testid="tabRelatedVideos"]').length){
        $('li[data-testid="tabRelatedVideos"] a').text(translation('videaproduktu'));
        $("#productVideos").find("h3").each(function() {
            let $h3 = $(this);
            let $iframe = $h3.next("iframe");

            if ($iframe.length) {
                $h3.add($iframe).wrapAll('<div class="videoBlock"></div>');
            }
        });
    }
    if($('li[data-testid="tabAlternativeProducts"]').length){
        $('li[data-testid="tabAlternativeProducts"] a').text(translation('podobneprodukty'))
    }

    if ($('.p-thumbnails-wrapper .p-thumbnails-inner').length) {
        $('.p-image-wrapper').addClass('haveThumbnails')
    }

    if($('.variant-list').length>0){
        $('.variant-list, .add-to-cart').hide();
        $('#p-detail-tabs li.active').removeClass('active');
        $('#tab-content #description').removeClass('active in');
        $('#p-detail-tabs li').first().before('<li class="shp-tab active" data-testid="customVariants"><a href="#customVariants" class="shp-tab-link" role="tab" data-toggle="tab">'+translation('vsechnyVarianty')+'</a><ul class="subvariant"></ul><ul class="subPosts"></ul></li>');
        $('#tab-content').prepend(`<div id="customVariants" class="tab-pane fade active in acordeonOpen" role="tabpanel"><div class="variantControls">
                                <span class="btn btn-cart add-to-cart-button">
                                    ${translation('pridatdokosiku')}
                                </button>
                            </div></div>`);
        $('.detail-parameters tr').each(function () {
        let th = $(this).find('th .row-header-label');
        let td = $(this).find('td');
            if (th.length && th.text().includes('#variantPost -')) {
                $(this).hide();
                let fullText = th.text().trim();
                let title = fullText.split('#variantPost -')[1].trim().replace(':', '');
                let url = td.text().trim();
                $('#customVariants').append(`
                     <div class="subPostItem">
                        <a href="${url}">${title}</a>
                    </div>    
                `)
                $('.subPosts').append(`
                    <li class="subPostItem">
                        <a href="${url}">${title}</a>
                    </li>
                `);
            }
        });
        const shoptetCodes = getShoptetDataLayer('product').codes;
        $.ajax({
            url: 'https://php.shopcode.cz/api/celtic-supply/api-detailProducts.php',   // <- tvoje API
            method: 'POST',
            data: {
                codes: JSON.stringify(shoptetCodes)
            },
            dataType: 'json',

            success: function(res) {
                if (!res.success) {
                    console.warn('API chyba:', res);
                    return;
                }

                const groups = res.groups;
                 $('#tab-content #customVariants').append(`
                        <div class="customVariantWrap"></div>
                `);
                let index = 0;
                const visibleLimit = 50;
                let totalVariants = Object.values(groups).reduce((sum, variants) => sum + variants.length, 0);
                Object.keys(groups).sort(function(a, b) {
                    return a.localeCompare(b, 'cs', { numeric: true, sensitivity: 'base' });
                }).forEach(function(groupName) {

                    groups[groupName].sort(sortVariants);

                    var slugName = groupName.toLowerCase()
                        .normalize("NFD").replace(/[\u0300-\u036f]/g, '')
                        .replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '');

                    /*$('#tab-content #customVariants').append(`
                        <div class="customVariantWrap" data-wrap="${slugName}"></div>
                    `);*/

                   

                    const allVariants = groups[groupName];
                    const total = allVariants.length;
                   
                    
                   // const wrap = $(`.customVariantWrap[data-wrap="${slugName}"]`);
                   const wrap = $(`.customVariantWrap`);

                    allVariants.forEach(function(variant) {

                        let matchedVariant = null;

                        Object.keys(shoptet.variantsSplit.necessaryVariantData).forEach(function(key) {
                            let v = shoptet.variantsSplit.necessaryVariantData[key];
                            if (v.code === variant.code) {
                                matchedVariant = v;
                                const info = getVariantInfoFromShoptet(key);
                                matchedVariant.variantLabel = info.label;
                                matchedVariant.variantId = info.variantId;
                            }
                        });
if (!matchedVariant) return;
                        let priceWithVat = parsePrice(matchedVariant.priceUnformatted);
                    let priceWithoutVat = priceWithVat / koefDph;
                    let hiddenClass = index >= visibleLimit ? ' hiddenVariant' : '';
 const priceNumber = parseVariantPrice(matchedVariant.priceUnformatted || matchedVariant.price);
                    const standardPriceNumber = parseVariantPrice(matchedVariant.standardPrice);

                    const showStandardPrice =
                        standardPriceNumber !== null &&
                        priceNumber !== null &&
                        standardPriceNumber > priceNumber;
                    const variantHtml = $(`
                            <div class="customVariant${hiddenClass}" data-unit-price="${priceNumber !== null ? priceNumber : 0}">
                                <div class="variantImage">
                                    <img src="${matchedVariant.variantImage.detail_small}" alt="${matchedVariant.name}">
                                </div>
                                <div class="variantRight">
                                    <div class="variantRightLeft">
                                        <span class="name">
                                            <img src="${matchedVariant.variantImage.detail_small}" alt="${matchedVariant.name}">
                                            ${matchedVariant.variantLabel}
                                        </span>
                                        <div class="availcode">
                                            <div class="stock" style="color:${matchedVariant.availabilityColor}">
                                                ${matchedVariant.availabilityName}
                                            </div>
                                            <div class="code">
                                                ${translation('code')}: ${matchedVariant.code}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="variantRightRight">
                                        <div class="price">
                                             <div class="top">
                                                ${showStandardPrice ? `<span class="priceStandard">${matchedVariant.standardPrice}</span>` : ''}
                                                <strong>${matchedVariant.price}</strong>
                                                ${matchedVariant.additionalPrice ? `<span class="price-additional">${matchedVariant.additionalPrice} ${translation('bezDph')}</span>` : ''}
                                            </div>
                                        </div>
                                        <div class="addCart">
                                            <form action="/action/Cart/addCartItem/" method="post" class="variant-submit csrf-enabled">
                                                <fieldset>
                                                    <input type="hidden" name="productId" 
                                                        value="${$('#product-detail-form meta[itemprop="productID"]').attr('content')}">
                                                    <input type="hidden" name="priceId" value="${matchedVariant.id}">
                                                    <span class="quantity">
                                                        <label>
                                                            <input type="number"
                                                                name="amount"
                                                                value="0"
                                                                class="amount"
                                                                autocomplete="off"
                                                                data-decimals="0"
                                                                step="1"
                                                                min="0"
                                                                max="9999">
                                                        </label>
                                                        <button class="increase" type="button"></button>
                                                        <button class="decrease" type="button"></button>
                                                    </span>
                                                    <button type="submit" class="btn btn-cart add-to-cart-button">
                                                        ${translation('VlozitDoKosiku')}
                                                    </button>
                                                </fieldset>
                                            </form>
                                        </div>
                                         <div class="variantBonus" data-code="${matchedVariant.code}">
                                            <span class="bonusLoading"></span></span>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        `);

                       const bonusWrap = variantHtml.find('.variantBonus');
                    wrap.append(variantHtml);

                
                        console.log('Volám bonus pro:', matchedVariant.code, priceWithVat, priceWithoutVat);
                    loadVariantBonus(matchedVariant.code, priceWithVat, priceWithoutVat)
                        .done(function(bonusRes) {
                            const points = bonusRes.amount || bonusRes.body || bonusRes.points || null;

                            if (!points) {
                                bonusWrap.empty();
                                return;
                            }

                           bonusWrap.attr('data-unit-points', points).data('unitPoints', points).html(`
                                <div class="bonusPoints">
                                    <strong>+ </strong><strong class="bonusPointsValue">0</strong> ${bonusProgrammText}
                                </div>
                            `);
                        })
                        .fail(function(xhr) {
                            console.warn('Bonus API chyba pro variantu:', matchedVariant.code, xhr);
                            bonusWrap.empty();
                        });

                    index++;
                });
                    
                    
                    
                    
                });
                if (totalVariants > visibleLimit) {
                        let hiddenCount = totalVariants - visibleLimit;
                        let word;
                        if (hiddenCount === 1) word = translation('varianta');
                        else if (hiddenCount >= 2 && hiddenCount <= 4) word = translation('varianty');
                        else word = translation('variant');

                        $('#customVariants .variantControls').prepend(`

                                <span class="btn btn-variant">
                                    +${hiddenCount} ${word}
                                </span>
                         
                        `);
                    }
            },


            error: function(xhr, status, err) {
                console.error("AJAX error:", err);
            }
        }).done(function(){
            initVariantQuantityLogic($('.customVariantWrap'));
        });
        
    }

    $(document).ready(function(){
        $("#p-detail-tabs>.shp-tab>a").each(function () {
            const link = $(this);
            const target = link.attr("href");
            const title = $.trim(link.text());
            const panel = $("#tab-content").find(target);
            if (panel.length) {
                if (!panel.find(".accordion-title").length) {
                    $("<span class='accordion-title'>" + title + "</span>").prependTo(panel);
                }
                panel.find(".accordion-title").on("click", function () {
                    panel.toggleClass("acordeonOpen");
                });
            }
        });
    })

}

function getVariantInfoFromShoptet(codeCombo) {
    if (!codeCombo.includes('-')) return { label: null, variantId: null };

    const [paramId, valueId] = codeCombo.split('-');

    const select = document.querySelector(`select[data-parameter-id="${paramId}"]`);
    if (!select) return { label: null, variantId: null };

    // Najdeme option
    const option = select.querySelector(`option[value="${valueId}"]`);
    if (!option) return { label: null, variantId: null };

    return {
        label: option.textContent.trim(),
        variantId: valueId
    };
}

function updateMainImage(highlightedThumbnail) {
    var findHighlighted = highlightedThumbnail.attr('href');
    var findHighlightedAlt = highlightedThumbnail.find('img').attr('alt');
    $('.p-image a.p-main-image').attr('href', findHighlighted).find('img').attr({'src': findHighlighted, 'alt': findHighlightedAlt});
}


$('html').on("click", ".subvariant li span", function () {
    let target = $(this).data("display");
    $(".subvariant li span").removeClass("active");
    $(this).addClass("active");
    if ($(`.customVariantWrap[data-wrap="${target}"]`).length) {
        $(".customVariantWrap").hide();
        $(`.customVariantWrap[data-wrap="${target}"]`).show();
    }
});

$(document).on("input change", ".customVariant input.amount", function () {
    let amount = parseInt($(this).val(), 10) || 0;
    let variantBox = $(this).closest(".customVariant");
    let btn = variantBox.find(".customAddtoCart");
    if (amount > 0) {
        btn.removeClass("notBuy");
    } else {
        btn.addClass("notBuy");
    }
    applyQuantityDiscountForCustomInput(amount);
});




function parseVariantName(name) {
    let parts = {
        text: name.toLowerCase(),  // základ pro abecedu
        size: null,                // první celé číslo
        thickness: null,           // desetinné číslo
    };

    // najdi první celé číslo (např. 1, 3, 5...)
    let sizeMatch = name.match(/\b(\d+)\b/);
    if (sizeMatch) {
        parts.size = parseInt(sizeMatch[1], 10);
    }

    // najdi tloušťku (0,25 nebo 0.35 → převedeme na číslo)
    let thickMatch = name.match(/(\d+[,.]\d+)\s*mm/i);
    if (thickMatch) {
        parts.thickness = parseFloat(thickMatch[1].replace(",", "."));
    }

    return parts;
}

function sortVariants(a, b) {
    let A = parseVariantName(a.name);
    let B = parseVariantName(b.name);

    // 1) Seřaď Safety/Liner/Shader podle textu
    let textCmp = A.text.localeCompare(B.text, "cs", { numeric: true, sensitivity: "base" });
    if (textCmp !== 0) return textCmp;

    // 2) Podle velikosti (1, 3, 5…)
    if (A.size !== B.size) {
        return (A.size || 0) - (B.size || 0);
    }

    // 3) Podle tloušťky (0.25 / 0.30 / 0.35…)
    if (A.thickness !== B.thickness) {
        return (A.thickness || 0) - (B.thickness || 0);
    }

    return 0;
}

$('html').on("click", ".variantControls .btn-variant", function (e) {
    e.preventDefault();

    let btn = $(this);
    let scrollTop = $(window).scrollTop();

    // animovaně schovat tlačítko
    btn.fadeOut(200, () => btn.remove());

    // připravit customVariant na animaci
    let block = $('.customVariantWrap .customVariant.hiddenVariant');

    // pokud byl blok skrytý přes .hiddenVariant, odstraň ji
    block.removeClass('hiddenVariant');

    // nejdřív schovat (bez skoku), pak animovat
    block
        .css({ opacity: 0, display: 'flex' })    // zobrazit ale neviditelně
        .slideDown(250)                            // výška animace
        .animate({ opacity: 1 }, 250);             // fade animace

    // zachovat pozici scrollu
  //  $(window).scrollTop(scrollTop);
});

$(document).on("click", ".variantControls .btn-cart", function () {
    const wrap = $(this).closest('#customVariants, .customVariantWrap');
    let totalAmount = 0;
    wrap.find(".customVariant").each(function () {
        let amount = Number($(this).find("input.amount").val()) || 0;
        if (amount > 0) {
            let codeText = $(this).find('input[name="priceId"]').attr('value');
            shoptet.cartShared.addToCart({
                priceId: codeText,
                amount: amount
            }, true);

            totalAmount += amount;;
        }
    });

    if (totalAmount === 0) {
        showMessage(translation('nevybranemnozstvi'), 'error', '', false, true);
    } else {
        showMessage(translation('pridano')+' '+totalAmount+' '+translation('polozek'), 'success', '', false, true);
    }
});

function parseDiscountFlag(text) {
    if (!text) return null;
    const lower = text.toLowerCase();
    if (!lower.includes("sleva") || !lower.includes("s kódem")) {
        return null;
    }
    const percentMatch = text.match(/(\d+)\s*%/);
    const percent = percentMatch ? parseInt(percentMatch[1], 10) : null;
    const codeMatch = text.match(/s kódem\s+(.+)$/i);
    const code = codeMatch ? codeMatch[1].trim() : null;
    return { percent, code };
}

function initVariantQuantityLogic($wrap) {

    /**
     * Načte aktuální množstevní slevy přímo z tabulky Shoptetu.
     *
     * Tabulka se při změně varianty přerenderuje, proto ji neukládáme
     * do globální proměnné, ale vždy ji načteme znovu.
     */
    function getQuantityDiscountTiers() {
        var tiers = [];

        $('.js-quantity-discounts__item').each(function () {
            var $item = $(this);

            var from = parseFloat($item.attr('data-amount'));
            var ratio = parseFloat($item.attr('data-price-ratio'));

            if (!Number.isFinite(from) || !Number.isFinite(ratio)) {
                return;
            }

            tiers.push({
                from: from,
                ratio: ratio
            });
        });

        tiers.sort(function (a, b) {
            return a.from - b.from;
        });

        return tiers;
    }

    $wrap.find('.customVariant').each(function () {
        var $variant = $(this);

        // Zabrání opakovanému navázání eventů.
        if ($variant.data('quantityLogicInitialized')) {
            return;
        }

        $variant.data('quantityLogicInitialized', true);

        var $amountInput = $variant.find("input[name='amount']");
        var $increase = $variant.find('.increase');
        var $decrease = $variant.find('.decrease');

        var $infoBox = $('<div class="variantQtyInfo"></div>');

        // Základní cena konkrétní varianty.
        var unitPrice = parseVariantPrice(
            $variant.attr('data-unit-price')
        ) || 0;

        $variant.after($infoBox);

        /**
         * Vrátí aktuální a následující množstevní hladinu.
         */
        function getTierData(qty) {
            var tiers = getQuantityDiscountTiers();

            // Pokud Shoptet tabulku nezobrazí, použijeme základní cenu.
            if (!tiers.length) {
                tiers = [
                    {
                        from: 1,
                        ratio: 1
                    }
                ];
            }

            var current = tiers[0];
            var next = null;

            for (var i = 0; i < tiers.length; i++) {
                if (qty >= tiers[i].from) {
                    current = tiers[i];
                } else {
                    next = tiers[i];
                    break;
                }
            }

            return {
                current: {
                    from: current.from,
                    ratio: current.ratio,
                    price: unitPrice * current.ratio
                },

                next: next
                    ? {
                        from: next.from,
                        ratio: next.ratio,
                        price: unitPrice * next.ratio
                    }
                    : null
            };
        }

        function renderInfo(qty) {
            if (qty <= 0 || !unitPrice) {
                $infoBox.empty();
                return;
            }

            var tierData = getTierData(qty);

            var current = tierData.current;
            var next = tierData.next;

            var html =
                `${translation('nyninakupujete')} ` +
                `${qty} ` +
                `${qty === 1 ? translation('kus') : translation('kusu')} ` +
                `${translation('za')} ` +
                `<strong>` +
                `${Number(current.price).ShoptetFormatAsCurrency()}` +
                `</strong>. `;

            if (next) {
                var diff = next.from - qty;

                html +=
                    `${translation('pridejteJeste')} ` +
                    `<strong>${diff} ${translation('ks')}</strong> ` +
                    `${translation('aziskate')} ` +
                    `<span>` +
                    `${Number(next.price).ShoptetFormatAsCurrency()}` +
                    `/${translation('ks')}.` +
                    `</span>`;
            } else {
                html += translation('nejlepsicena');
            }

            $infoBox.html(html);
        }

        function renderBonus(qty) {
            var $bonusWrap = $variant.find('.variantBonus');
            var $bonusValue = $bonusWrap.find('.bonusPointsValue');

            if (!$bonusWrap.length || !$bonusValue.length) {
                return;
            }

            var unitPoints =
                parseFloat($bonusWrap.attr('data-unit-points')) || 0;

            if (!unitPoints) {
                return;
            }

            var totalPoints = qty > 0
                ? unitPoints * qty
                : unitPoints;

            $bonusValue.text(
                formatBonusPoints(totalPoints)
            );
        }

        function updateVariantQtyInfo(qty) {
            renderInfo(qty);
            renderBonus(qty);
        }

        $increase.on('click.variantQuantityLogic', function () {
            var currentQty =
                parseFloat($amountInput.val()) || 0;

            var step =
                parseFloat($amountInput.attr('step')) || 1;

            updateVariantQtyInfo(currentQty + step);
        });

        $decrease.on('click.variantQuantityLogic', function () {
            var currentQty =
                parseFloat($amountInput.val()) || 0;

            var step =
                parseFloat($amountInput.attr('step')) || 1;

            var min =
                parseFloat($amountInput.attr('min')) || 0;

            var qty = Math.max(
                min,
                currentQty - step
            );

            updateVariantQtyInfo(qty);
        });

        $amountInput.on(
            'input.variantQuantityLogic change.variantQuantityLogic',
            function () {
                var qty =
                    parseFloat($(this).val()) || 0;

                updateVariantQtyInfo(qty);
            }
        );
    });
}

function formatBonusPoints(value) {
    var number = Number(value);

    if (!Number.isFinite(number)) {
        return value;
    }

    if (number % 1 === 0) {
        return number.toString();
    }

    return number.toFixed(2).replace('.', ',');
}

$('.p-info-wrapper a[data-toggle="tab"][href="#description"]').on('click', function(e){
    e.preventDefault();
    const offset = 60;
    setTimeout(() => {
        const top = $('#description').offset().top - offset;
        $('html, body').animate({ scrollTop: top }, 400);
    }, 50);
});

$('html').on('click', '.detailFixedCart .addToCart', function(){
    shoptet.cartShared.addToCart({priceId: $(this).data('code')});
})


function parsePrice(value) {
    if (value === undefined || value === null) return 0;

    return String(value)
        .replace(/\s/g, '')
        .replace(/[^\d,.-]/g, '')
        .replace(',', '.')
        .replace(/(?!^)-/g, '') * 1;
}



function loadVariantBonus(code, priceWithVat, priceWithoutVat) {
        console.log('loadVariantBonus start:', code, priceWithVat, priceWithoutVat);


    return $.ajax({
        url: `https://europe-central2-mehub-cz.cloudfunctions.net/services-bonus-service/affd1f31-b55d-4687-9f2a-c19baf72db1f/696ce5e3-31c8-4f08-b2da-536e775276fa/products/${encodeURIComponent(code)}/credit`,
        method: 'GET',
        dataType: 'json',
        data: {
            priceWithVat: priceWithVat,
            priceWithoutVat: priceWithoutVat,
            currency: 'EUR'
        }
    });
}

function parseVariantPrice(price) {
    if (price === null || price === undefined || price === '') {
        return null;
    }

    if (typeof price === 'number') {
        return isNaN(price) ? null : price;
    }

    let cleaned = String(price)
        .replace(/&nbsp;/gi, ' ')
        .replace(/\u00A0/g, ' ')
        .trim();

    // necháme jen čísla, čárky, tečky, minus a mezery
    cleaned = cleaned.replace(/[^\d,.\-\s]/g, '');

    // pryč s normálními mezerami kvůli "1 500 Kč"
    cleaned = cleaned.replace(/\s+/g, '');

    if (!cleaned) {
        return null;
    }

    const hasComma = cleaned.indexOf(',') !== -1;
    const hasDot = cleaned.indexOf('.') !== -1;

    // 1.234,56 => 1234.56
    if (hasComma && hasDot && cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) {
        cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    }

    // 1,234.56 => 1234.56
    else if (hasComma && hasDot && cleaned.lastIndexOf('.') > cleaned.lastIndexOf(',')) {
        cleaned = cleaned.replace(/,/g, '');
    }

    // 10,5 => 10.5
    // 1,5 => 1.5
    // 1,500 => 1500 nebo 1.5? Tady bereme jako tisíce, pokud jsou za čárkou přesně 3 čísla.
    else if (hasComma) {
        const parts = cleaned.split(',');

        if (parts.length === 2 && parts[1].length === 3 && parts[0].length >= 1) {
            cleaned = parts[0] + parts[1];
        } else {
            cleaned = cleaned.replace(',', '.');
        }
    }

    // 10.5 => 10.5
    // 1.500 => 1500, pokud jsou za tečkou přesně 3 čísla
    else if (hasDot) {
        const parts = cleaned.split('.');

        if (parts.length === 2 && parts[1].length === 3 && parts[0].length >= 1) {
            cleaned = parts[0] + parts[1];
        }
    }

    const number = Number(cleaned);

    return isNaN(number) ? null : number;
}